import { useSelector } from "react-redux";

import { StyleSpecification } from "maplibre-gl";

import { RootState } from "@/store";
import { MapSource } from "@/types/map";

export const useMapConfig = () => {
  const { baseMap, mapSource } = useSelector((state: RootState) => state.map);

  const mapboxAccessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

  // Validate provider
  if (![MapSource.MAPBOX, MapSource.STYLE_URL].includes(mapSource)) {
    throw new Error(
      `Invalid map provider: ${mapSource}. Must be one of:  mapbox, style-url`
    );
  }

  // Get style URL based on provider
  const getStyleConfig = (): StyleSpecification | string => {
    switch (mapSource) {
      case MapSource.MAPBOX:
        if (!mapboxAccessToken) {
          throw new Error(
            "Mapbox access token is required when using mapbox provider"
          );
        }
        return baseMap.value;
      case MapSource.STYLE_URL:
        if (!baseMap.value) {
          throw new Error(
            "Style URL is required when using style-url provider"
          );
        }
        return baseMap.value;
      default:
        throw new Error(`Unsupported map provider: ${mapSource}`);
    }
  };

  return {
    getMapStyle: getStyleConfig()
  };
};
